import "./ProyectosCommon.css";
import { BaseSmallModalFormComponent } from "../../../shared/components/modal/BaseSmallModalFormComponent";
import { GastoResponse } from "../../../shared/response/proyectos/ProyectoResponse";
import { GastoSavePayload } from "../../../shared/services/api/payload/proyectos/GastoSavePayload";
import { GastoSaveService } from "../../services/proyectos/GastoSaveService";

/** Modal pequeño para registrar/editar un gasto real de un ítem del proyecto. */
export class GastoModal extends BaseSmallModalFormComponent<
  GastoResponse,
  GastoSavePayload,
  GastoSaveService
> {
  private _fecha!:     HTMLInputElement;
  private _cantidad!:  HTMLInputElement;
  private _precio!:    HTMLInputElement;
  private _proveedor!: HTMLInputElement;
  private _obs!:       HTMLTextAreaElement;

  constructor(
    private readonly _proyectoId: string,
    private readonly _itemId: string,      // id del CatalogoItem
    private readonly _itemNombre: string,
    private readonly _onSavedCb: (g: GastoResponse) => void,
    private readonly _gasto?: GastoResponse,
  ) {
    super(new GastoSaveService());
  }

  protected get title(): string { return this._gasto ? "Editar gasto" : "Registrar gasto"; }
  protected get saveText(): string { return "Guardar"; }

  protected renderBody(): string {
    const g = this._gasto;
    const fechaVal = g?.fecha ? new Date(g.fecha).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);
    return `
      <div class="cl-form-fields">
        <div class="cl-form-group">
          <label class="cl-form-label">${this._esc(this._itemNombre)}</label>
          <div class="pr-form-note" style="margin-bottom:6px">El total (cantidad × precio) lo calcula el backend.</div>
        </div>
        <div class="pr-form-row">
          <div class="cl-form-group">
            <label class="cl-form-label" for="ga-fecha">Fecha <span class="cl-required">*</span></label>
            <input id="ga-fecha" class="sx-input" type="date" value="${fechaVal}">
          </div>
          <div class="cl-form-group">
            <label class="cl-form-label" for="ga-cant">Cantidad real <span class="cl-required">*</span></label>
            <input id="ga-cant" class="sx-input sx-input--numeric" type="number" min="0" step="0.01" value="${g?.cantidadReal ?? ""}" placeholder="0">
          </div>
        </div>
        <div class="cl-form-group">
          <label class="cl-form-label" for="ga-precio">Precio unitario real (COP) <span class="cl-required">*</span></label>
          <input id="ga-precio" class="sx-input sx-input--numeric" type="number" min="0" step="1" value="${g?.precioUnitarioReal ?? ""}" placeholder="0">
        </div>
        <div class="cl-form-group">
          <label class="cl-form-label" for="ga-prov">Proveedor</label>
          <input id="ga-prov" class="sx-input" type="text" value="${this._esc(g?.proveedor ?? "")}" placeholder="Proveedor…">
        </div>
        <div class="cl-form-group">
          <label class="cl-form-label" for="ga-obs">Observaciones</label>
          <textarea id="ga-obs" class="sx-input" rows="2" style="resize:vertical">${this._esc(g?.observaciones ?? "")}</textarea>
        </div>
      </div>
    `;
  }

  protected override onAfterRender(el: HTMLDivElement): void {
    this._fecha     = el.querySelector<HTMLInputElement>("#ga-fecha")!;
    this._cantidad  = el.querySelector<HTMLInputElement>("#ga-cant")!;
    this._precio    = el.querySelector<HTMLInputElement>("#ga-precio")!;
    this._proveedor = el.querySelector<HTMLInputElement>("#ga-prov")!;
    this._obs       = el.querySelector<HTMLTextAreaElement>("#ga-obs")!;
    [this._cantidad, this._precio].forEach((i) => i.addEventListener("input", () => this._validate()));
    this._validate();
  }

  protected buildPayload(): GastoSavePayload {
    return {
      id: this._gasto?.id ?? null,
      proyectoId: this._proyectoId,
      itemId: this._itemId,
      fecha: this._fecha.value ? new Date(this._fecha.value).toISOString() : new Date().toISOString(),
      cantidadReal: Number(this._cantidad.value) || 0,
      precioUnitarioReal: Math.max(0, Math.floor(Number(this._precio.value) || 0)),
      proveedor: this._proveedor.value.trim() || null,
      observaciones: this._obs.value.trim() || null,
    };
  }

  protected override onSaved(item: GastoResponse): void {
    this._onSavedCb(item);
    this.dispose();
  }

  private _validate(): void {
    const ok = Number(this._cantidad.value) > 0 && Number(this._precio.value) >= 0 && this._precio.value.trim() !== "";
    this.setSaveDisabled(!ok);
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
  }
}
